import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  ValidationErrors,
  Validators
} from '@angular/forms';
import { Location } from '@angular/common';
import { CommonModule } from "@angular/common";
import { AuthService } from '../../services/auth-service';
import Swal from 'sweetalert2';

// import { ProjectService } from '../services/project.service';
// import { AlertService } from '../services/alert.service';

@Component({
  selector: 'app-change-password',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './change-password.component.html',
  styleUrl: './change-password.component.css'
})
export class ChangePasswordComponent implements OnInit {
  @Input() navigateBackOnSuccess = true;
  // opened from the Profile menu (not forced at login): different text and a Cancel button
  @Input() optional = false;
  @Output() passwordChanged = new EventEmitter<void>();
  @Output() cancelled = new EventEmitter<void>();

  changePasswordForm!: FormGroup;
  showChangePasswordModal = true;
  passwordSubmitted = false;
  showOldPassword = false;
  showNewPassword = false;
  showConfirmPassword = false;
  userData: any;
  isError = false;
  err: any;

  public authService = inject(AuthService)


  constructor(
    private fb: FormBuilder,
    private location: Location
  ) { }

  ngOnInit(): void {

    this.userData = JSON.parse(
      localStorage.getItem('user_details') || '{}'
    );

    this.changePasswordForm = this.fb.group(
      {
        // oldPassword: [
        //   '',
        //   [
        //     Validators.required,
        //     Validators.minLength(8)
        //   ]
        // ],

        newPassword: [
          '',
          [
            Validators.required,
            Validators.minLength(8),
            Validators.maxLength(20),
            Validators.pattern(
              /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]+$/
            )
          ]
        ],

        confirmPassword: [
          '',
          [
            Validators.required,
            Validators.minLength(8)
          ]
        ]
      },
      {
        validators: this.passwordMatchValidator
      }
    );
  }

  get f() {
    return this.changePasswordForm.controls;
  }

  /**
   * Confirm password must match new password
   */
  passwordMatchValidator(
    form: AbstractControl
  ): ValidationErrors | null {

    const newPassword = form.get('newPassword')?.value;
    const confirmPassword = form.get('confirmPassword');

    if (!confirmPassword) {
      return null;
    }

    if (
      newPassword &&
      confirmPassword.value &&
      newPassword !== confirmPassword.value
    ) {
      confirmPassword.setErrors({
        ...confirmPassword.errors,
        passwordMismatch: true
      });
    } else if (confirmPassword.hasError('passwordMismatch')) {

      const errors = { ...confirmPassword.errors };

      delete errors['passwordMismatch'];

      confirmPassword.setErrors(
        Object.keys(errors).length ? errors : null
      );
    }

    return null;
  }


  /**
   * New password must be different from old password
   */
  newPasswordDifferentValidator(
    form: AbstractControl
  ): ValidationErrors | null {

    const oldPassword = form.get('oldPassword')?.value;
    const newPassword = form.get('newPassword')?.value;

    if (
      oldPassword &&
      newPassword &&
      oldPassword === newPassword
    ) {
      const newPasswordControl = form.get('newPassword');

      if (newPasswordControl) {
        newPasswordControl.setErrors({
          ...newPasswordControl.errors,
          sameAsOld: true
        });
      }

      return {
        sameAsOld: true
      };
    }

    return null;
  }


  togglePassword(
    type: 'old' | 'new' | 'confirm'
  ): void {

    if (type === 'old') {
      this.showOldPassword = !this.showOldPassword;
    }

    if (type === 'new') {
      this.showNewPassword = !this.showNewPassword;
    }

    if (type === 'confirm') {
      this.showConfirmPassword = !this.showConfirmPassword;
    }
  }


  changePassword(): void {
    this.passwordSubmitted = true;
    if (this.changePasswordForm.invalid) {
      this.changePasswordForm.markAllAsTouched();
      return;
    }
    const request = {
      // userId: this.userData?.userID,
      // oldPassword: this.f['oldPassword'].value,
      newPassword: this.f['newPassword'].value,
      confirmPassword: this.f['confirmPassword'].value
    };
    console.log('Change Password Request:', request);

    this.authService.ChangePassword(
      request
    ).subscribe({
      next: (response: any) => {
        console.log('Password changed successfully:', response);
        // Important: don't allow the modal to appear again
        this.showChangePasswordModal = false;
        this.changePasswordForm.reset();
        this.passwordSubmitted = false;
        // The user stays signed in: only the change-password flags are cleared. Read the
        // session again (the tokens may have been refreshed since the popup opened) and
        // keep new tokens when the response sends them.
        const session = JSON.parse(localStorage.getItem('user_details') || '{}');
        session.forceChangePassword = false;
        session.mustChangePassword = false;
        const tokens = response?.data?.tokens;
        if (tokens?.accessToken) {
          session.tokens = { ...session.tokens, ...tokens };
        }
        localStorage.setItem('user_details', JSON.stringify(session));
        this.userData = session;

        Swal.fire({
          title: 'Success',
          text: response.message,
          icon: 'success',
          showCancelButton: false,
          confirmButtonText: 'OK',
          cancelButtonText: 'No'
        })
        .then(() => {
          this.passwordChanged.emit();
          if (this.navigateBackOnSuccess) {
            this.goBack();
          }
        });
      },

      error: (err:any) => {
        this.isError = true;
       this.err = err;
       console.error('Error changing password:', err);
        Swal.fire({
          title: 'Error',
          text: err.error.message,
          icon: 'error',
          showCancelButton: false,
          confirmButtonText: 'OK',
          cancelButtonText: 'No'
        })
      }
    });

  }


  goBack(): void {
    this.location.back();
  }
}


